import { openModal } from '@core/components/ModalStack';
import { AutomationTriggerModalProps } from './AutomationTriggerModal';

export async function openTriggerModal(props: AutomationTriggerModalProps) {
  const { AutomationTriggerModal } = await import('./AutomationTriggerModal');

  openModal(AutomationTriggerModal, props);
}
